import { Option } from "../../../../types/Option";

export const getOptionKey = <T>(optionOrValue: Option<T> | T): string => {
	const value =
		typeof optionOrValue === "object" && optionOrValue !== null && "value" in optionOrValue
			? (optionOrValue as Option<T>).value
			: optionOrValue;

	return typeof value === "object" && value !== null ? JSON.stringify(value) : String(value);
};
